import React, { useContext } from "react";
import "./ToolsSection.css";
import { useNavigate } from "react-router-dom";
import { SearchModalContext } from "../context/SearchModalContext";
import clgListImg from "../assets/clglist.png";
import nonCapImg from "../assets/noncappdf.png";
import predictorImg from "../assets/clgpredict.png";
import explorerImg from "../assets/clgexplore.png";

export default function ToolsSection() {

  const navigate = useNavigate();

  // ✅ Get openSearch from context
  const { openSearch } = useContext(SearchModalContext);

  // ✅ College Explorer → Open same modal like Sidebar
  const openCollegeExplorer = () => {
    openSearch();
  };

  // College Predictor
  const openCollegePredictor = () => {
    navigate("/predict", { state: { directOpen: true } });
  };

  return (
    <div className="tools-main">

      <h2>Everything You Need for Engineering Admission — In One App</h2>

      <div className="tools-grid">

       {/* Preference Form */}
          <div className="tool-card">
            <img src={clgListImg} alt="Preference List" className="tool-image" />
            <h3>Preference List Creation</h3>
            <p>Get error-free, preference list with multiple strategies</p>

            <button onClick={() => navigate("/preference-form")}>
              CREATE PREFERENCES
            </button>
          </div>

                {/* CAP */}
          <div className="tool-card">
            <img src={nonCapImg} alt="CAP Counseling" className="tool-image" />
            <h3>CAP and Non-CAP Counseling</h3>
            <p>Complete guidance for CAP,ACAP and ILS rounds</p>

            <button onClick={() => navigate("/non-cap-admissions")}>
              ADMISSION PROCESS
            </button>
          </div>

              {/* Predictor */}
              <div className="tool-card">
                <img src={predictorImg} alt="College Predictor" className="tool-image" />
                <h3>College Predictor</h3>
                <p>Know which colleges and branches are realistic</p>

                <button onClick={openCollegePredictor}>
                  CHECK COLLEGES
                </button>
              </div>


                    {/* Explorer */}
              <div className="tool-card">
                <img src={explorerImg} alt="College Explorer" className="tool-image" />
                <h3>College Explorer</h3>
                <p>Compare cutoffs, fees, intake and placements</p>

                <button onClick={openCollegeExplorer}>
                  EXPLORE COLLEGES
                </button>
              </div>


      </div>

    </div>
  );
}
